export const MAX_CHILD_DEPTH = 2;

export const PAGE_SIZE = 100;

export const COPYWRITING = {
  NOT_FOUND_ERROR_MESSAGE: "Sorry, this objective does not exist.",
  LOADING_OBJECTIVE: "Loading objective...",
  NO_CHILD_OBJECTIVES_AVAILABLE: "No child objectives available.",
};
